import {
  Configuration,
  TestDecision,
  TestDecisionTexts,
} from "@/shared-module/models";
import { ConfigurationService } from "@/shared-module/services";
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from "@angular/core";
import { SubSink } from "subsink";
import { CreateTestDecisionDialogComponent } from "..";
import * as _ from "lodash";

@Component({
  selector: "app-test-decisions-footer",
  templateUrl: "testdecisionsfooter.component.html",
})
export class TestDecisionsFooterComponent implements OnDestroy {
  @ViewChild("dialog", { static: true })
  dialog: CreateTestDecisionDialogComponent;
  data: TestDecision[];
  @Input() texts: TestDecisionTexts;
  @Input("data") set setdata(_data: TestDecision[]) {
    this.data = _data;
    this.displayTestDecisionsFooter = !this.isTeamDecisionSelected();
  }
  @Output() environmentCreate: EventEmitter<string> = new EventEmitter();
  @Output() environmentSelect: EventEmitter<number> = new EventEmitter();
  @Output() environmentTeamSelect: EventEmitter<void> = new EventEmitter();
  subs = new SubSink();
  rgbColor: string;
  state: string = "default";
  displayTestDecisionsFooter: boolean;

  constructor(private configurationService: ConfigurationService) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.rgbColor = c?.rgb;
      },
    );
  }

  dialogConfirmed(value: string) {
    this.environmentCreate.emit(value);
  }

  openCreateDialog() {
    this.dialog.open();
  }

  openTestDecision(id: number) {
    this.environmentSelect.emit(id);
  }

  openTeamDecision() {
    this.toggleDisplayTestDecisionsFooter();
    this.environmentTeamSelect.emit();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  popupShown() {
    this.state = "rotated";
  }

  popupHidden() {
    this.state = "";
  }

  isTeamDecisionSelected() {
    const selected = _.find(this.data, (el) => el.current);
    return selected == null;
  }

  getSelectedtestDecision() {
    const selected = _.find(this.data, (el) => el.current);
    if (selected == null) return null;
    return selected.name;
  }

  toggleDisplayTestDecisionsFooter() {
    this.displayTestDecisionsFooter = !this.displayTestDecisionsFooter;
  }
}
